import {config} from 'src/config'

export function getRandomCeil(upLevel: number): number {
  return Math.floor(Math.random() * (upLevel+1))
}

export function getRandomIndexWithCheck(callbackCheck: (index:number) => boolean, upLevel: number) {
  let index: number = getRandomCeil(upLevel)
  let attempt = 1
  while (callbackCheck(index) && attempt < config.countSkipGuessedRiddles) {
    index = getRandomCeil(upLevel)
    attempt++
  }
  return index
}
